const gameGridConfig = [
    [
    	// 1.1
        {
            type: 'antivirus',
            top: true,
            bottom: false,
            left: true,
            right: false
        },
        // 1.2
        {
            type: 'point',
            top: true,
            bottom: false,
            left: false,
            right: true
        },
        // 1.3
        {
            type: 'point',
            top: true,
            bottom: false,
            left: false,
            right: false
        },
        // 1.4
        {
            type: 'point',
            top: true,
            bottom: true,
            left: false,
            right: false
        },
        // 1.5
        {
            type: 'point',
            top: true,
            bottom: true,
            left: false,
            right: false
        },
        // 1.6
        {
            type: 'point',
            top: true,
            bottom: false,
            left: false,
            right: false
        },
        // 1.7
        {
            type: 'point',
            top: true,
            bottom: true,
            left: false,
            right: false
        },
        // 1.8
        {
            type: 'point',
            top: true,
            bottom: true,
            left: false,
            right: false
        },
        // 1.9
        {
            type: 'point',
            top: true,
            bottom: false,
            left: false,
            right: true
        },
        // 1.10
        {
            type: 'point',
            top: true,
            bottom: false,
            left: false,
            right: false
        },
        // 1.11
        {
            type: 'antivirus',
            top: true,
            bottom: false,
            left: false,
            right: true
        }
    ],
    [
        // 2.1
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: true
        },
        // 2.2
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 2.3
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 2.4
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 2.5
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 2.6
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 2.7
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 2.8
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 2.9
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 2.10
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 2.11
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        }
    ],
    [
        // 3.1
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: true
        },
        // 3.2
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 3.3
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 3.4
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 3.5
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 3.6
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 3.7
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 3.8
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 3.9
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 3.10
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 3.11
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        }
    ],
    [
        // 4.1
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: true
        },
        // 4.2
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 4.3
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 4.4
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 4.5
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: false
        },
        // 4.6
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 4.7
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 4.8
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 4.9
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 4.10
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 4.11
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        }
    ],
    [
        // 5.1
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: false
        },
        // 5.2
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 5.3
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 5.4
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 5.5
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: false
        },
        // 5.6
        {
            type: 'end',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 5.7
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 5.8
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 5.9
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 5.10
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 5.11
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        }
    ],
    [
        // 6.1
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: true
        },
        // 6.2
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 6.3
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 6.4
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 6.5
        {
            type: 'point',
            top: false,
            bottom: true,
            left: true,
            right: false
        },
        // 6.6
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 6.7
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: true
        },
        // 6.8
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 6.9
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 6.10
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 6.11
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        }
    ],
    [
        // 7.1
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: true
        },
        // 7.2
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 7.3
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 7.4
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 7.5
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 7.6
        {
            type: 'antivirus',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 7.7
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 7.8
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 7.9
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 7.10
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 7.11
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        }
    ],
    [
        // 8.1
        {
            type: 'point',
            top: false,
            bottom: false,
            left: true,
            right: true
        },
        // 8.2
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 8.3
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 8.4
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 8.5
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 8.6
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 8.7
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 8.8
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: true
        },
        // 8.9
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 8.10
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        },
        // 8.11
        {
            type: 'point',
            top: false,
            bottom: false,
            left: false,
            right: true
        }
    ],
    [
        // 9.1
        {
            type: 'antivirus',
            top: false,
            bottom: true,
            left: true,
            right: false
        },
        // 9.2
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: true
        },
        // 9.3
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 9.4
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 9.5
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 9.6
        {
            type: 'blank',
            top: false,
            bottom: false,
            left: false,
            right: false
        },
        // 9.7
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 9.8
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 9.9
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 9.10
        {
            type: 'point',
            top: false,
            bottom: true,
            left: false,
            right: false
        },
        // 9.11
        {
            type: 'antivirus',
            top: false,
            bottom: true,
            left: false,
            right: true
        }
    ]
];

export {
	gameGridConfig
};